module.exports = __webpack_public_path__ + "img/linh-thai.1438ef21.jpeg";